export default ({ route }) => {
  const locale = route.params.locale

  if (locale === 'pt-br') {
    const handtalkScript = document.createElement('script')
    handtalkScript.src = 'https://plugin.handtalk.me/web/latest/handtalk.min.js'
    handtalkScript.id = 'handtalkId'

    handtalkScript.onload = () => {
      const ht = new HT({
        token: '6c87e51d3de96e073573a3c3929c4f2f',
        avatar: 'MAYA',
      })
    }

    document.body.appendChild(handtalkScript)
  }
}
